import {Component, OnInit, ViewChild} from '@angular/core';
import {AnalysisService} from "../../../services/analysis.service";
import {TranslocoService} from "@ngneat/transloco";
import {AnalysisComponent} from "../analysis.component";
import {AuthGuard} from "../../../common/auth-guard.service";
import {MachineAnalysis} from "../../../model/machine-analysis";
import {GenericGraphComponent} from "../../shared/generic-graph/generic-graph.component";
import {ExportFileType} from "../../../model/export-file-type";

@Component({
  selector: 'app-analysis-general',
  templateUrl: './analysis-general.component.html',
  styleUrls: ['./analysis-general.component.scss']
})
export class AnalysisGeneralComponent implements OnInit {

  @ViewChild('topMachinesChart')
  public topMachinesChart: GenericGraphComponent;

  public rows: number = 10;
  public first: number = 0;
  public totalSqueezedFruits: number;
  public totalTopMachines: number = 0;

  public serialNumbersAndAlias: string[];
  public totalSqueezedFruitsGraphData: any;
  public totalSqueezedFruitsTableData: MachineAnalysis[] = [];
  public plotOptions: any;
  public pointFormat: string = '{series.name}: {point.y}';

  public dataModeOptions;
  public chartMode: boolean = true;
  public dataLoaded: boolean = false;

  public exportVisible: boolean;
  public language: string;


  constructor(private analysisService: AnalysisService,
              private i18n: TranslocoService,
              public readonly authGuard: AuthGuard) {
  }

  ngOnInit(): void {
    this.language = this.i18n.getActiveLang();
    this.loadData();
    this.i18n.selectTranslation().subscribe(() => {
      this.buildDataModeOptions();
    })
  }

  private buildDataModeOptions(): void {
    this.dataModeOptions = [
      {name: this.i18n.translate("misc.mode.chart"), code: true},
      {name: this.i18n.translate("misc.mode.table"), code: false}
    ];
  }

  private loadData(): void {
    this.dataLoaded = false;
    this.buildTotalSqueezedFruitsData();
  }

  private buildTotalSqueezedFruitsData(): void {
    this.plotOptions = AnalysisComponent.getPlotOptionsColumnChart();
    this.i18n.selectTranslate('attribute.squeezedFruits').subscribe(() => {
      const totalFruitsDataSeries = [{data: [], name: this.i18n.translate('attribute.squeezedFruits')}];

      this.serialNumbersAndAlias = [];
      this.analysisService.getAnalysisGeneral().subscribe(response => {
        this.totalSqueezedFruits = response.analysisData.totalSqueezedFruits;
        response.analysisData.topMachines.forEach((machine) => {
          this.serialNumbersAndAlias.push(machine.serial + ' (' + machine.alias + ')');
          totalFruitsDataSeries[0].data.push(machine.totalSqueezedFruits);
        });
        this.totalSqueezedFruitsGraphData = totalFruitsDataSeries;
        this.totalSqueezedFruitsTableData = response.analysisData.topMachines;
        this.totalTopMachines = this.totalSqueezedFruitsTableData.length;
        this.dataLoaded = true;
      });
    });
  }

  public getContentExport() {
    return [this.totalSqueezedFruits, this.totalSqueezedFruitsTableData];
  }

    public readonly ExportFileType = ExportFileType;
}
